export const makeImg = (url, params) => {
    if (!url) {
        return '';
    }

    const urlObj = new URL(url);
    Object.keys(params).forEach((key) => {
        urlObj.searchParams.set(key, params[key]);
    });
    return urlObj.toString();
};
